import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { loginUser } from "../../store/action/userAction";
import { connect } from "react-redux";
import { URL } from "../../routers/constants";
import { LOGIN_URL_SSO } from "../../config/config";

const Login = (props) => {
   const { loginUser } = props;
   const location = useLocation();
   const navigate = useNavigate();
   const query = new URLSearchParams(location.search);
   useEffect(() => {
      const ticket = query.get('ticket');
      if (ticket != null) {
         loginUser(ticket, navigate);
      } else {
         window.open(LOGIN_URL_SSO, '_self');
      }
   }, [])
   return (
      <div>

      </div>
   );
}

const mapStateToProps = (state) => {
   return {
   };
};

export default connect(mapStateToProps, {
   loginUser
})(Login);